// TODO: Need to remove therapyOptions and use nivolumabOptions instead
export const therapyOptions = [
    {
      label: "Neoadjuvant (before surgery)",
      value: "Neoadjuvant (before surgery)",
    },
    {
      label: "Adjuvant (after surgery)",
      value: "Adjuvant (after surgery)",
    },
    {
      label: "Metastatic 1st line",
      value: "Metastatic 1st line",
    },
    {
      label: "Metastatic 2nd line & beyond",
      value: "Metastatic 2nd line & beyond",
    },
  ]

  export const vivitraStatusOptions = [
    {
      label: "Ordered",
      value: "Ordered",
    },
    {
      label: "Shipped",
      value: "Shipped",
    },
    {
      label: "Delivered",
      value: "Delivered",
    },
  ];
  export const SIGRIMA = "sigrima";

  export const sigrimaDrugOptions = [
    { label: "Sigrima", value: "Sigrima" },
    { label: "Others", value: "Others" },
  ];